import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";


import {getMeetingByEntity, getTaskByEntity, getTaskById} from "../../http/fundLync/entityAndAddress.helper";
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";



const TableActionsComponent = ({ rowData, onEditTask, onViewTask }) => {
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  
  const navigateToEdit = (id) => {
    const encryptedId = btoa(id.toString());
      navigate(
        `/edit-task/${encodeURIComponent(
          encryptedId
        )}`
      );
  };

  const navigateToDetails = (rowData) => {
    const encryptedId = btoa(rowData.id.toString());
    let url;
      url = `/task-details/${encodeURIComponent(encryptedId)}`;
      navigate(url);
  };
  


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
            onClick={() => {
              onEditTask(rowData.id);
            }}
            >
            <i
                className="mdi mdi-pencil font-size-16 text-success me-1"
                id="edittooltip"
            ></i>
            Edit
            <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
            </UncontrolledTooltip>
            </DropdownItem>
            
            <DropdownItem
                onClick={() => {
                  onViewTask(rowData.id);
                }}
            >
                <i
                className="mdi mdi-eye font-size-16 text-success me-1"
                id="viewTooltip"
                ></i>
                View
                <UncontrolledTooltip placement="top" target="viewTooltip">
                  View
                </UncontrolledTooltip>
            </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const EntityTaskTable = ({ onCreateNewtask, onEditTask, onViewTask }) => {
  document.title = "Meeting Table | Fundlync";

  const navigate = useNavigate();
  const [taskList, setTaskList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const userObj = decryptedValue(localStorage.getItem("user")) || "{}";
  const { entityType } = userObj || "";
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });
  const [entityId, setEntityId] = useState();

  const urlParams = new URLSearchParams(window.location.search);
  const filterType = urlParams.get("filter");
  let decodeFilterType = atob(urlParams.get("filter"));

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const encodedId = urlParams.get("id");
      if (encodedId) {
          const decodedId = atob(encodedId);
          setEntityId(decodedId);
      } else {
          const entity = decryptedValue(localStorage.getItem("user"));
          setEntityId(entity.entityId);
      }
  }, []);

  const navigateToDeal = async (Id) => {
    try {
      const dealInfoResponse = await getTaskById({ Id });
      const entityId = dealInfoResponse.dealId;
      try {
        const encryptedId = btoa(entityId.toString());
        if(userObj.roleName === "fundLync_cutomer"){
          navigate(`/customer/viewDeal?id=${encodeURIComponent(encryptedId)}`);
        }else{
          navigate(`/${userObj.roleName}/viewDeal?id=${encodeURIComponent(encryptedId)}`);
        }
      } catch (entityError) {
        console.error('Error fetching entity details:', entityError);
      }
    } catch (dealError) {
      console.log('Error fetching entity details:', dealError)
    }
  };

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = 'underline';
  };
  const handleMouseLeave = (event) => {
    event.target.style.color = "#21aa47";
    event.target.style.textDecoration = 'none';
  };
  const statusColors = {
    "Open": "#3a99db", // blue
    "Completed": "#34c38f", // green
    "In Progress": "#ffc107", // yellow
    "Cancelled": "#f46a6a", // red
  };

  const priorityStyles = {
    "High": { backgroundColor: "#f8d7da", color: "#721c24" }, // light red background, dark red text
    "Medium": { backgroundColor: "#fff3cd", color: "#856404" }, // light yellow background, dark yellow text
    "Low": { backgroundColor: "#d1ecf1", color: "#0c5460" }, // light blue background, dark blue text
    "default": { backgroundColor: "#f0f0f0", color: "#6c757d" } // light grey background, dark grey text
  };

  const entityDetails = decryptedValue(localStorage.getItem("user"));
  let handleChangeDeal;
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          handleChangeDeal = () => {
            navigateToDeal(cellProps.value)
          }
          return cellProps.value || "";
        },
      },
      {
        Header: "Deal Name",
        accessor: "dealId",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original?.deal
          return (
            <div
            onClick={handleChangeDeal}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer', color: '#21aa47', width: '160px' }}
            title={rowData?.dealName || ''}
          >
            { rowData?.dealName }
          </div>
          );
        }
      },
      {
        Header: "Task Name",
        accessor: "taskName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Task Type",
        accessor: "taskType",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Task Status",
        accessor: "taskStatus",
        
        filterable: true,
        Cell: (cellProps) => {
          const status = cellProps.value || "";
          const color = statusColors[status] || "#6c757d"; // default gray if no match
          return (
            <span style={{ color: color, fontWeight: 'bold' }}>
              {status}
            </span>
          );
        },
      },
      {
        Header: "Task Priority",
        accessor: "taskPriority",
        filterable: true,
        Cell: (cellProps) => {
          const priority = cellProps.value || "";
          const style = priorityStyles[priority] || "";
          return (
            <div
            style={{
              backgroundColor: style.backgroundColor,
              color: style.color,
              padding: "5px 10px",
              borderRadius: "5px",
              width: "100px", 
              height: "30px", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              textAlign: "center",
            }}
            >
              {priority}
            </div>
          );
        },
      },
      {
        Header: "Due Date",
        accessor: "dueDate",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
         // return TableActionsComponent(rowData, entityType);
          return (
            <TableActionsComponent
              rowData={rowData}
              onEditTask={onEditTask}
              onViewTask={onViewTask}
            />
          );
        },
      },
    ],
    []
  );

    const convertTo12HourFormat = (time) => {
      let [hours, minutes] = time.split(':');
      hours = parseInt(hours, 10);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert to 12-hour format
      return `${hours}:${minutes} ${ampm}`;
   };
    
   // Format date
   function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    
    return `${day}-${month}-${year}`;
  }
  

  const getTaskList = (data, entityId) => {
    const requestData = { ...data, entityId };

    getTaskByEntity(requestData)
      .then((responseFromAPI) => {
        if (responseFromAPI.status && responseFromAPI.code === 200) {
          const formattedTask = responseFromAPI.data.data.map(task => {
            return {
              ...task,
              dueDate: formatDate(task.dueDate),
            };
          });
          setTaskList(formattedTask);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data;
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        } else {
          setTaskList([]);
          setPagination({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching meetings", error);
      });
};

const handlePageChange = (
  page,
  pageSize,
  searchKey=searchValue,
  columnName = columnId,
  sortingOrder = sortingOrderStatus
) => {
  setPageSize(pageSize);
  const data = {
    page,
    limit: pageSize,
    searchKey,
    columnName,
    sortingOrder,
  };
  if (filterType) {
    data.filterType = decodeFilterType;
  }
  getTaskList(data, entityId); 
};

const handleSortColumn = (option) => {
  setSortingOptions(option);
  const columnName = option.column;
  setColumnId(columnName);
  const sortingOrder = option.isAsc ? "asc" : "desc";
  setSortingOrderStatus(sortingOrder);
  handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
};

const handleSearchFilter = (value, pageSize) => {
  if (filterType) {
    if (value) {
      setSearchValue(value);
      handlePageChange(1, pageSize, value);
    } else {
      setSearchValue(decodeFilterType);
      handlePageChange(1, pageSize, decodeFilterType);
    }
  } else {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  }
};

const handleClearSearch = () => {
  if (filterType) {
    setSearchValue(decodeFilterType);
    handlePageChange(1, pageSize, decodeFilterType);
  } else {
    setSearchValue("");
    handlePageChange(1, pageSize, "");
  }
};

useEffect(() => {
  if (entityId) {
    if (filterType) {
      getTaskList({ searchKey: `${decodeFilterType}` }, entityId);
    } else {
      getTaskList({}, entityId);
    }
  }
}, [entityId, filterType]); 

useEffect(() => {
  checkPermissions();
}, []);

  const checkPermissions = async () => {
    const isNewEntitypermission = await isPermission(
      "apiConfiguration",
      "create_permission"
    );
    setIsNewEntityPermission(isNewEntitypermission);
  };
  const navigateToAddTask = () => {
    const encryptedId = btoa(entityId.toString());
    let url = `/${entityDetails.roleName}/add-task?id=${encryptedId}`;
    navigate(url);
  };

  const buttonSection = (
    <div className="text-sm-end">
        <Button
          type="button"
          style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }}
          className="mb-2 me-2"
          onClick={onCreateNewtask}
        >
          <i className="mdi mdi-plus me-1" />
          {"Create Task"}
        </Button>
    </div>
  );

  
  return (
    <React.Fragment>
      <Col xs="12">
          <TableContainerV1
              columns={columns}
              data={taskList}
              pagination={pagination}
              handlePageChange={handlePageChange}
              handleSearchFilter={handleSearchFilter}
              sortOptions={sortingOptions}
              customSection={buttonSection}
              handleSortColumn={handleSortColumn}
              handleClearSearch={handleClearSearch}
              className="custom-header-css"
          />
      </Col>
    </React.Fragment>
  );
};

export default EntityTaskTable;
